import { EnhancedModalFrame as Frame } from './enhanced-modal-frame';
import { ModalHeader as Header } from './modal-header';
import { ModalBody as Body } from './modal-body';
import { ModalFooter as Footer } from './modal-footer';

const Modal = { Frame, Header, Body, Footer };

export default Modal;
